var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.894 21c-.68 0-1.277-.076-1.303-.078a.697.697 0 0 1-.598-.593L9.8 18.93a7.306 7.306 0 0 1-1.243-.526l-1.107.831a.696.696 0 0 1-.84-.006c-.019-.015-.494-.385-.976-.864l-.074-.077c-.481-.481-.849-.956-.865-.976a.69.69 0 0 1-.004-.841l.853-1.13a7.124 7.124 0 0 1-.504-1.248L3.669 13.9a.695.695 0 0 1-.59-.599C3.075 13.278 3 12.68 3 12v-.108c0-.679.076-1.275.078-1.3a.695.695 0 0 1 .593-.6l1.405-.191c.135-.429.311-.843.524-1.239l-.835-1.11a.696.696 0 0 1 .006-.84c.015-.02.385-.495.864-.977l.077-.074c.481-.481.956-.851.976-.865a.69.69 0 0 1 .841-.004l1.131.857c.4-.207.816-.375 1.247-.504l.193-1.376a.695.695 0 0 1 .599-.59C10.722 3.075 11.32 3 12 3h.108c.679 0 1.275.076 1.3.078a.695.695 0 0 1 .6.593l.191 1.405c.429.137.841.311 1.239.524l1.11-.835a.696.696 0 0 1 .84.006c.02.015.495.385.977.864l.074.077c.481.481.851.956.867.976.19.249.191.593.002.841l-.857 1.13c.209.398.377.815.506 1.246l1.376.195c.307.045.55.29.589.599.004.023.078.622.078 1.301v.108c0 .679-.074 1.275-.078 1.3a.693.693 0 0 1-.593.6l-1.401.191a7.354 7.354 0 0 1-.526 1.24l.833 1.11a.693.693 0 0 1-.006.84c-.015.019-.385.494-.864.976l-.077.074c-.48.481-.956.851-.976.865a.69.69 0 0 1-.841.004l-1.131-.86a7.21 7.21 0 0 1-1.245.505l-.195 1.378a.691.691 0 0 1-.597.59c-.025.003-.624.079-1.303.079h-.106z",
    stroke: "#FFF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    cx: 12,
    cy: 12,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.ac16d18c4f09dde816164cb590fcb8dd.svg";
export { ForwardRef as ReactComponent };